import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from "@angular/router";

import { map, share } from "rxjs";

import { TenantDataService } from "@core/services/datasources/tenant-data.service";
import { TenantUtilities } from "@core/utilities";



export function validTenantGuard(): CanActivateFn {
  return (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const tenantDataService: TenantDataService = inject(TenantDataService);
    const router: Router = inject(Router);

    return tenantDataService.getIsValidTenant().pipe(share(), map((isValid: boolean) => {
      if (isValid) { return true; }

      const loginTree: UrlTree = router.parseUrl(`${TenantUtilities.default_tenant}/demo`);
      return loginTree;
    }));
  };
}
